import React from 'react';
import { Modal } from '../../components/modals/antd-modals';
import { BasicFormWrapper } from '../styled';
import { Button } from '../../components/buttons/buttons';

const DeleteTopCarSale = ({ visible, onCancel, handleDelete, carSale }) => {
  return carSale ? (
    <Modal
      visible={visible}
      type="primary"
      title="Delete Car Sales Data"
      onCancel={onCancel}
      footer={[
        <div key="date-top-car-sale" className="car-modal-footer">
          <Button size="default" type="danger" key="submit" onClick={() => handleDelete(carSale._id)}>
            Delete
          </Button>
          <Button size="default" type="white" key="black" outlined="true" onClick={onCancel}>
            Cancel
          </Button>
        </div>,
      ]}
    >
      <div className="car-modal">
        <BasicFormWrapper>
          <p>Delete Top Car Sale ?</p>
        </BasicFormWrapper>
      </div>
    </Modal>
  ) : (
    <></>
  );
};

export default DeleteTopCarSale;
